<template>
    <div class="slide">
        <!-- 轮播图 -->
        <el-carousel :interval="8000" height="350px" trigger="click" width="100%" :autoplay="true">
            <el-carousel-item v-for="(item, index) in options" :key="index">
                <img :src="item.src" class="carousel-image"/>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    name: 'SlideShow',
    data() {
        return {
            options: [
                { src: require('@/assets/img/cddm1.png') },
                { src: require('@/assets/img/cddm2.png') },
                { src: require('@/assets/img/cddm3.png') },
                { src: require('@/assets/img/cddm4.png') },
                { src: require('@/assets/img/cddm5.png') },
                { src: require('@/assets/img/cddm6.png') },
                { src: require('@/assets/img/cddm7.png') },
                { src: require('@/assets/img/cddm8.png') },
                // {src:require('@/assets/img/cddm9.png')},
            ]
        }
    },

    methods: {

    }

}
</script>

<style scoped>

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
</style>